<template>
  <div
    v-if="showLandingPattern"
    id="landingBannerPattern"
    data-testid="sbx-pcc_landingBannerPattern"
    :style="cssProps"
    :class="[{ fullWidth: this.overlay == 'full' }, this.screenSize]"
  >
    <landing-banner-base v-bind="{ ...$props }" />
  </div>
  <landing-banner-base v-else v-bind="{ ...$props }" />
</template>

<script>
import LandingBannerBase from './LandingBannerBase.vue';
import { landingBanner } from './index';

export default {
  name: 'landingBannerPattern',
  components: { LandingBannerBase },
  props: {
    ...landingBanner.propTypes,
    screenSize: String,
    screenPx: Number,
  },
  computed: {
    showLandingPattern() {
      return this.pattern;
    },
    isFullWidthPattern() {
      return this.overlay === 'full';
    },
    cssProps() {
      return {
        backgroundImage: `url('${this.pattern}')`,
        width: this.isFullWidthPattern ? `${this.screenPx}px` : '100%',
        maxWidth: this.isFullWidthPattern ? `${this.screenPx}px` : '100%',
        margin:
          this.maxViewSize === 'fullWidth' && this.screenPx > 1230 && this.overlay !== 'fullWidth'
            ? `0 -${(this.screenPx - 1230) / 2}px`
            : '0 auto',
      };
    },
  },
};
</script>

<style lang="scss">
@import '@/SharedFe/scss/variables.scss';

#landingBannerPattern {
  width: 100%;
  background-repeat: repeat;
  margin: 0 auto;

  .landingImageWrapper img {
    display: block;
  }

  .mainLandingWrapper {
    max-width: 1280px;
    flex-wrap: nowrap;
  }

  &.max-view-fullWidth {
    .mainLandingWrapper {
      @media (min-width: 1230px) {
        max-width: 100%;
      }
    }
  }

  .mainLandingWrapper .full {
    width: 100%;
    margin: auto;
  }

  .mainLandingWrapper .half {
    margin: auto;
  }

  .mainLandingWrapper .overlayBackgroundWrapper.half {
    justify-content: center;
    @media (min-width: $mobile) and (max-width: $contained) {
      width: 50%;
      left: 0;
    }
  }
}

@media screen and (max-width: $mobile) {
  #landingBannerPattern {
    display: flex;
    justify-content: center;
  }
}
</style>
